











import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ControlHover extends Vue {
  private config() {
    this.$emit("config");
  }
  private del() {
    this.$emit("del");
  }
}
